import { useTranslation } from 'react-i18next';
import { useCMSSportsBonuses } from '@/modules/bonuses';
import { Card } from '../AllOffers/components/Card';

import { ScAllOffers, ScCardRow } from './styled';

export const Sports = () => {
  const { t } = useTranslation('bonuses');

  const { bonuses } = useCMSSportsBonuses();

  return (
    <ScAllOffers>
      {bonuses.length ? (
        <ScCardRow>
          {bonuses.map((bonus) => (
            <Card key={bonus.id} {...bonus} />
          ))}
        </ScCardRow>
      ) : (
        <div className="no-offers">{t('tabs.empty')}</div>
      )}
    </ScAllOffers>
  );
};
